var _style, _title, _g;
var _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgExpressServicesIcon = function SvgExpressServicesIcon(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 360 250",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none",
    className: "",
    style: {}
  }), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#020203;}\n\t.st1{fill:#E30613;}\n\t.st2{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg_1",
    className: ""
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M234.26000122070315,128.6900018310547 c-0.31000000000000005,0 -0.6400000000000001,-0.030000000000000006 -0.9600000000000001,-0.09000000000000002 c-2.84,-0.53 -4.72,-3.25 -4.19,-6.1 l2.83,-15.27 c0.53,-2.84 3.24,-4.71 6.1,-4.19 c2.84,0.53 4.72,3.25 4.19,6.1 l-2.83,15.27 C238.9300012207031,126.93000183105471 236.73000122070312,128.6900018310547 234.26000122070315,128.6900018310547 z",
    id: "svg_3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M219.10000122070312,210.55000183105471 c-0.31000000000000005,0 -0.6400000000000001,-0.030000000000000006 -0.9600000000000001,-0.09000000000000002 c-2.84,-0.53 -4.72,-3.26 -4.19,-6.1 l2.83,-15.27 c0.53,-2.84 3.24,-4.71 6.1,-4.19 c2.84,0.53 4.72,3.26 4.19,6.1 l-2.83,15.27 C223.77000122070314,208.79000183105467 221.58000122070314,210.55000183105471 219.10000122070312,210.55000183105471 z",
    id: "svg_5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M235.03000122070313,60.740001831054684 c-0.31000000000000005,0 -0.6400000000000001,-0.030000000000000006 -0.9600000000000001,-0.09000000000000002 c-2.84,-0.53 -4.72,-3.25 -4.19,-6.09 l4.24,-22.94 c0.53,-2.84 3.24,-4.71 6.1,-4.19 c2.84,0.53 4.72,3.25 4.19,6.09 l-4.24,22.94 C239.70000122070314,58.98000183105469 237.51000122070315,60.740001831054684 235.03000122070313,60.740001831054684 z",
    id: "svg_7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M258.65000122070313,60.740001831054684 c-0.31000000000000005,0 -0.6400000000000001,-0.030000000000000006 -0.9600000000000001,-0.09000000000000002 c-2.84,-0.53 -4.72,-3.25 -4.19,-6.1 l4.25,-22.94 c0.53,-2.84 3.24,-4.71 6.1,-4.19 c2.84,0.53 4.72,3.25 4.19,6.1 l-4.25,22.94 C263.32000122070315,58.98000183105469 261.1200012207031,60.740001831054684 258.65000122070313,60.740001831054684 z",
    id: "svg_9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M319.93000122070316,96.99000183105471 c-1.49,0 -2.96,-0.6300000000000001 -4,-1.86 c-1.86,-2.21 -1.58,-5.51 0.6200000000000001,-7.37 l26.25,-22.15 l-5.46,-6.7 l-26.11,22.03 c-2.21,1.87 -5.51,1.58 -7.37,-0.6200000000000001 c-1.86,-2.21 -1.58,-5.51 0.6200000000000001,-7.37 l30.18,-25.46 c1.07,-0.9 2.47,-1.34 3.8600000000000003,-1.21 c1.4,0.13 2.68,0.8200000000000001 3.5700000000000003,1.9 l12.07,14.81 c1.8,2.21 1.5,5.46 -0.6800000000000002,7.3 l-30.18,25.47 C322.32000122070315,96.59000183105468 321.1200012207031,96.99000183105471 319.93000122070316,96.99000183105471 z",
    id: "svg_11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M278.0300012207031,35.1900018310547 h-52.93 c-2.75,0 -5.29,-1.17 -6.98,-3.2 c-1.71,-2.06 -2.4,-4.8100000000000005 -1.8900000000000001,-7.5600000000000005 l2.88,-15.58 c0.92,-4.97 5.5600000000000005,-8.85 10.57,-8.85 h52.93 c2.74,0 5.29,1.17 6.98,3.2 c1.71,2.06 2.4,4.8100000000000005 1.8900000000000001,7.5600000000000005 l-2.88,15.58 C287.6800012207031,31.300001831054686 283.0400012207031,35.1900018310547 278.0300012207031,35.1900018310547 zM226.8100012207031,24.730001831054693 h51.22 c0.030000000000000006,-0.030000000000000006 0.24000000000000002,-0.22000000000000003 0.29000000000000004,-0.33000000000000007 l2.58,-13.94 h-51.16 c-0.12000000000000001,0.05000000000000001 -0.31000000000000005,0.22000000000000003 -0.35000000000000003,0.33000000000000007 L226.8100012207031,24.730001831054693 zM282.6100012207031,10.460001831054683 h0.030000000000000006 H282.6100012207031 z",
    id: "svg_13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M209.35000122070312,263.23000183105466 c-28.3,0 -53.03,-10.99 -69.63,-30.94 c-16.98,-20.4 -23.37,-47.57 -18.02,-76.49 C132.47000122070312,97.62000183105471 188.6100012207031,50.280001831054676 246.83000122070314,50.280001831054676 c28.3,0 53.03,10.99 69.63,30.94 c16.97,20.41 23.37,47.57 18.02,76.5 C323.71000122070313,215.8900018310547 267.57000122070315,263.23000183105466 209.35000122070312,263.23000183105466 zM246.83000122070314,60.740001831054684 c-53.43,0 -104.95,43.5 -114.85,96.97 c-4.78,25.81 0.8200000000000001,49.93 15.77,67.9 c14.57,17.52 36.44,27.16 61.58,27.16 c53.43,0 104.95,-43.5 114.85,-96.97 c4.78,-25.81 -0.8200000000000001,-49.93 -15.78,-67.9 C293.84000122070313,70.3800018310547 271.9700012207031,60.740001831054684 246.83000122070314,60.740001831054684 z",
    id: "svg_15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M213.19000122070315,242.5000018310547 c-22.83,0 -42.79,-8.870000000000001 -56.19,-24.99 c-13.71,-16.47 -18.88,-38.39 -14.56,-61.71 c8.66,-46.75 53.77,-84.79 100.56,-84.79 c22.83,0 42.79,8.870000000000001 56.19,24.99 c13.71,16.48 18.88,38.39 14.56,61.71 C305.09000122070313,204.46000183105468 259.9800012207031,242.5000018310547 213.19000122070315,242.5000018310547 zM243.0000012207031,81.47000183105467 c-41.99,0 -82.49,34.2 -90.27,76.23 c-3.74,20.21 0.6300000000000001,39.07 12.31,53.11 c11.38,13.68 28.48,21.21 48.15,21.21 c41.99,0 82.49,-34.2 90.27,-76.23 c3.74,-20.21 -0.6300000000000001,-39.07 -12.31,-53.11 C279.76000122070315,89.0100018310547 262.6700012207031,81.47000183105467 243.0000012207031,81.47000183105467 z",
    id: "svg_17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_18"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 183.79000854492188,
    y1: 88.58999633789062,
    x2: 15.330001831054688,
    y2: 88.58999633789062,
    id: "svg_19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M183.79000122070312,93.8200018310547 H15.330001220703139 c-2.89,0 -5.23,-2.34 -5.23,-5.23 c0,-2.89 2.34,-5.23 5.23,-5.23 h168.47 c2.89,0 5.23,2.34 5.23,5.23 C189.02000122070314,91.4800018310547 186.6800012207031,93.8200018310547 183.79000122070312,93.8200018310547 z",
    id: "svg_20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_21"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 173.70001220703125,
    y1: 196.2899932861328,
    x2: 5.2299957275390625,
    y2: 196.2899932861328,
    id: "svg_22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M173.69000122070315,201.52000183105469 H5.230001220703116 c-2.89,0 -5.23,-2.34 -5.23,-5.23 s2.34,-5.23 5.23,-5.23 h168.47 c2.89,0 5.23,2.34 5.23,5.23 S176.58000122070314,201.52000183105469 173.69000122070315,201.52000183105469 z",
    id: "svg_23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_24"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 164.5,
    y1: 148.2100067138672,
    x2: 72.20001220703125,
    y2: 148.2100067138672,
    id: "svg_25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M164.5000012207031,153.4400018310547 h-92.3 c-2.89,0 -5.23,-2.34 -5.23,-5.23 s2.34,-5.23 5.23,-5.23 h92.3 c2.89,0 5.23,2.34 5.23,5.23 S167.39000122070314,153.4400018310547 164.5000012207031,153.4400018310547 z",
    id: "svg_26"
  }))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExpressServicesIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ExpressServicesIcon.ab8b9fbd.svg";
export { ForwardRef as ReactComponent };